// extracted by mini-css-extract-plugin
module.exports = {"News":"News-module__News___2JoXj","content":"News-module__content___2waAn","tiles":"News-module__tiles___2CWja","Article":"News-module__Article___14Ibv"};